// extracted by mini-css-extract-plugin
export default {"skeleton":"DRuyov","skeletonButton":"Q436Ax","skeletonGroup":"jAZng7","infoIcon":"w0JUMQ","gradient":"PHfmF0"};